import SlickSlider from 'react-slick'
import styled from 'styled-components'

export const ProgressBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const Slider = styled(SlickSlider)`
  width: 100%;
`

export const Step = styled.div<{ $filled: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  width: 100%;
  color: ${({ theme, $filled }) =>
    $filled ? theme.colors.text.primary : theme.colors.coolGray.cool500};
`

export const StepLabel = styled.span<{ $current: boolean }>`
  font-size: 20px;
  margin-bottom: 24px;
  line-height: 20px;
  font-weight: ${({ $current }) => ($current ? 'bold' : '400')};
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme, $current }) =>
    $current ? theme.colors.text.primary : theme.colors.text.secondary};
`

export const StepContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
`

export const StepCircle = styled.div<{ $filled: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${({ theme, $filled }) =>
    $filled ? theme.colors.blackPearlBlue.shade600 : theme.colors.coolGray.cool150};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.brand.white};
    display: ${({ $filled }) => ($filled ? 'block' : 'none')};
  }
`

export const StepLine = styled.div<{
  $first: boolean
  $last: boolean
  $filled: boolean
  $current: boolean
}>`
  height: 12px;
  width: 100%;
  background-color: ${({ theme, $filled }) =>
    $filled ? theme.colors.blackPearlBlue.shade600 : theme.colors.coolGray.cool150};
  margin-left: 0;
  margin-right: 0;
  align-self: center;
  border-radius: ${({ $current, $first, $last }) => {
    const leftTop = $first ? '8px' : '0'
    const rightTop = $current || $last ? '8px' : '0'
    const rightBottom = $current || $last ? '8px' : '0'
    const leftBottom = $first ? '8px' : '0'
    return `${leftTop} ${rightTop} ${rightBottom} ${leftBottom}`
  }};
`
